//ScaleDependentRender.ts ==============================================================
import "../Util/Prototypes";

import * as MainMap from "../MainMap";
import * as Settings from "../Settings";
import * as Util_App from "./Util_App";

//Check for change in map scale for 2D only.
export function init() {

   //Wait for map scale to change.
   MainMap.mapView.watch("scale", function () {
      if (!MainMap.reBuildMapInProgress) {
         //Util.errMsg("Map scale changed to: " + MainMap.mapView.scale);
         setLineWidths();
         //setLabelSizes();
      }
   });
}

//Set line widths based on scale.
function setLineWidths() {
   let i: number;

   for (const scaleSetting of Settings.scaleDependentLines) {
      const layerName: string = scaleSetting.layerName;

      for (const operLay of Settings.operMaps) {
         if (operLay.id === layerName && operLay.serviceType === "FeatureLayer") {
            if (Util_App.isMapLayerVisible(layerName)) {

               for (i = 0; i < scaleSetting.scales.length; i++) {
                  const scale: number = scaleSetting.scales[i];
                  const pointSize: number = scaleSetting.pointSizes[i];

                  if (MainMap.mapView.scale < scale) {
                     const layer = Util_App.getOperationalLayerById(layerName) as __esri.FeatureLayer;

                     let renderer: any = layer.renderer;

                     //Get current point size.
                     let symbol: any;
                     if (renderer.type === "simple") {
                        symbol = renderer.symbol;
                     } else if (renderer.type === "unique-value") {
                        symbol = renderer.uniqueValueInfos[0].symbol;
                     }

                     if (!symbol) {
                        break;
                     }

                     let curPointSize: number = 0;
                     if (symbol.width) {
                        curPointSize = symbol.width;
                     } else if (symbol.outline) {
                        curPointSize = symbol.outline.width;
                     }

                     if (curPointSize === 0) {
                        break;
                     }

                     //Adjust width.
                     if (curPointSize !== pointSize) {
                        renderer = renderer.clone();

                        if (renderer.type === "simple") {
                           symbol = renderer.symbol;

                           if (symbol.width) {
                              symbol.width = pointSize;
                           } else {
                              symbol.outline.width = pointSize;
                           }

                        } else if (renderer.type === "unique-value") {
                           const infos: any = renderer.uniqueValueInfos;

                           for (const info of infos) {
                              symbol = info.symbol;

                              if (symbol.width) {
                                 symbol.width = pointSize;
                              } else {
                                 symbol.outline.width = pointSize;
                              }
                           }
                        }
                        //Util.errMsg("Setting " + layerName + " " + curPointSize + " to " + pointSize);
                        layer.renderer = renderer;
                     }
                     break;
                  }
               }
            }
         }
      }
   }
} //End function.

   //Set label font sizes based on scale.
   //function setLabelSizes() {
   //   let i: number;

   //   for (const scaleSetting of Settings.scaleDependentLabels) {
   //      const layerName: string = scaleSetting.layerName;

   //      for (const operLay of Settings.operMaps) {
   //         if (operLay.id === layerName && operLay.serviceType === "FeatureLayer") {
   //            if (Util_App.isMapLayerVisible(layerName)) {

   //               for (i = 0; i < scaleSetting.scales.length; i++) {
   //                  const scale: number = scaleSetting.scales[i];
   //                  const pointSize: number = scaleSetting.pointSizes[i];

   //                  if (MainMap.mapView.scale < scale) {
   //                     const layer: any = Util_App.getOperationalLayerById(layerName);

   //                     if (layer.labelingInfo) {
   //                        const curPointSize: number = layer.labelingInfo[0].symbol.font.size;

   //                        if (curPointSize !== pointSize) {
   //                           //Util.errMsg("Setting " + layerName + " " + curPointSize + " to " + pointSize);
   //                           const labelingInfo: any = layer.labelingInfo[0].clone();
   //                           labelingInfo.symbol.font.size = pointSize;
   //                           layer.labelingInfo = [labelingInfo];
   //                           //layer.refresh();
   //                        }
   //                     }
   //                     break;
   //                  }
   //               }
   //            }
   //         }
   //      }
   //   }
   //} //End function.
